import { render, staticRenderFns } from "./MarketingTools_coupon.vue?vue&type=template&id=70385140&scoped=true&"
import script from "./MarketingTools_coupon.vue?vue&type=script&lang=js&"
export * from "./MarketingTools_coupon.vue?vue&type=script&lang=js&"
import style0 from "./MarketingTools_coupon.vue?vue&type=style&index=0&id=70385140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70385140",
  null
  
)

export default component.exports